import { Link } from "react-router-dom";

const benefits = [
  "Reach customers actively searching in your area",
  "Free listing to start — upgrade only when you grow",
  "Leads, calls and WhatsApp enquiries in one place",
  "Verified badge to build instant local trust",
];

export default function CTASection() {
  return (
    <section id="list-business" className="bg-primary-900">
      <div className="mx-auto w-full max-w-[1400px] px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-700 bg-primary-950/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-accent-400">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-store-3-fill text-[13px]" />
              </span>
              For business owners
            </span>
            <h2 className="mt-5 font-heading text-2xl font-extrabold leading-tight text-background-50 md:text-4xl">
              Own a business on the Canara coast? Get found.
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              Join thousands of local businesses already listed on Coastal Bizz Connect. Start with a
              free listing and upgrade to sponsored placements whenever you are ready to grow.
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {benefits.map((benefit) => (
                <li key={benefit} className="flex items-start gap-2.5 text-sm text-background-200">
                  <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                    <i className="ri-check-double-line text-base" />
                  </span>
                  {benefit}
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/list-your-business"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors duration-200 hover:bg-accent-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-add-circle-line text-base" />
                </span>
                List Your Business Free
              </Link>
              <Link
                to="/listing-plans"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-700 px-6 py-3 text-sm font-semibold text-background-100 transition-colors duration-200 hover:border-accent-400 hover:text-accent-300"
              >
                Compare listing plans
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base" />
                </span>
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[
              { value: "4,080+", label: "Listed businesses", icon: "ri-store-3-line" },
              { value: "120K+", label: "Monthly visitors", icon: "ri-group-line" },
              { value: "45+", label: "Categories", icon: "ri-apps-2-line" },
              { value: "28K+", label: "Enquiries delivered", icon: "ri-send-plane-line" },
            ].map((item) => (
              <div
                key={item.label}
                className="flex flex-col items-center gap-2 rounded-lg border border-primary-700 bg-primary-950/40 px-4 py-6 text-center"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <span className="font-heading text-xl font-extrabold text-background-50">
                  {item.value}
                </span>
                <span className="text-xs text-background-300">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}